import { render } from "./IsoZones.vue?vue&type=template&id=9b36cd90&scoped=true"
import script from "./IsoZones.vue?vue&type=script&lang=js"
export * from "./IsoZones.vue?vue&type=script&lang=js"

import "./IsoZones.vue?vue&type=style&index=0&id=9b36cd90&lang=less&scoped=true"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b36cd90"]])

export default __exports__